import { Tooltip } from '@components/ui/Tooltip';
import type { EdgeBadge } from '@parlay-picker/shared/edgeStatus';
import { Info, Lock } from 'lucide-react';
import type React from 'react';

/**
 * The strategy score's slot before there is a score: locked for Free, or the count of settled bets
 * while the edge is not proven yet.
 */
export function EdgeStatusPill({
  badge,
  onUpgrade,
}: {
  badge: Extract<EdgeBadge, { kind: 'locked' | 'not_proven' }>;
  onUpgrade: () => void;
}): React.ReactElement {
  const locked = badge.kind === 'locked';
  return (
    <Tooltip content={badge.hint}>
      <button
        type="button"
        data-testid={locked ? 'edge-status-locked' : 'edge-status-not-proven'}
        onClick={locked ? onUpgrade : undefined}
        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap bg-theme-surface text-theme-text-secondary border border-theme-border shadow-sm ${
          locked ? 'cursor-pointer hover:text-theme-text' : 'cursor-help'
        }`}
      >
        {locked ? <Lock className="w-3 h-3" /> : <Info className="w-3 h-3" />}
        <span>{badge.label}</span>
      </button>
    </Tooltip>
  );
}
